import { createSelector } from '@reduxjs/toolkit';

const selectPerson = (state) => {
  return state.personsSearchStore;
};

export const getPersonsSearchData = createSelector([selectPerson], (personsSearchStore) => {
  return personsSearchStore?.data || [];
});
